import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Shop from "../pages/shop/page";
import WindSpinners from "../pages/collections/WindSpinners";
import SoapstoneAnimals from "../pages/collections/SoapstoneAnimals";
import WireWrappedStones from "../pages/collections/WireWrappedStones";
import Accessories from "../pages/collections/Accessories";
import ProductDetail from "../pages/product/page";
import About from "../pages/about/page";
import Contact from "../pages/contact/page";
import Cart from "../pages/cart/page";
import Checkout from "../pages/checkout/page";
import ShippingPolicy from "../pages/shipping-policy/page";
import ReturnsRefunds from "../pages/returns-refunds/page";
import PrivacyPolicy from "../pages/privacy-policy/page";
import TermsConditions from "../pages/terms-conditions/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/shop", element: <Shop /> },
  { path: "/collections/wind-spinners", element: <WindSpinners /> },
  { path: "/collections/soapstone-animals", element: <SoapstoneAnimals /> },
  { path: "/collections/wire-wrapped-stones", element: <WireWrappedStones /> },
  { path: "/collections/accessories", element: <Accessories /> },
  { path: "/product/:id", element: <ProductDetail /> },
  { path: "/about", element: <About /> },
  { path: "/contact", element: <Contact /> },
  { path: "/cart", element: <Cart /> },
  { path: "/checkout", element: <Checkout /> },
  { path: "/shipping-policy", element: <ShippingPolicy /> },
  { path: "/returns-refunds", element: <ReturnsRefunds /> },
  { path: "/privacy-policy", element: <PrivacyPolicy /> },
  { path: "/terms-conditions", element: <TermsConditions /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
